import MainLayout from '@/layouts/MainLayout'
import PageToScene from '@/scene/PageToScene'
import type { NextPage } from 'next'

const TodayFdsPage: NextPage = () => {
  return (
    <MainLayout>
      <PageToScene url="/todays-fds" title="Today's FDS" />
    </MainLayout>
  )
}

export default TodayFdsPage
